module.exports = __webpack_public_path__ + "static/media/desarrollos.a0651cca.jpg";